module.exports = __webpack_public_path__ + "static/media/4_of_hearts.6369d1c9.svg";